<div class="w-p-100 flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="m-b-0 flex-1-1-100">
        <mat-label>{{data.input?.fieldName}}</mat-label>
        <input matInput placeholder="" [(ngModel)]="data.input.name"
               [attr.data-cy]="data.input?.fieldName"
               particleAnalytics
               analyticsCategory="add-survey-dialog"
               analyticsAction="Survey-title" required>
    </mat-form-field>
</div>

